const payEstimateListTitleBarMenu = {
  contentType: "payEstimateList",
  menuItems: [
    {
      _menuId: "payEstimateListMenu_1",
      type: "TITLEBAR_MENU_ITEM",
      label: "New Estimate",
      action: "newEstimate",
    },
  ],
  toolbar: [
    {
      _iconId: "payEstimateListToolbar_1",
      type: "TITLEBAR_TOOLBAR_ICON",
      icon: "sync-alt",
      toggleValue: null,
      action: "refresh",
      toolTipText: "Refresh",
    },
  ],
};

export default payEstimateListTitleBarMenu;
